'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonicdchanges = require('./commonicdchanges.html');

var _commonicdchanges2 = _interopRequireDefault(_commonicdchanges);

var _commonicdchanges3 = require('./commonicdchanges.controller');

var _commonicdchanges4 = _interopRequireDefault(_commonicdchanges3);

require('./commonicdchanges.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonicdchangesComponent = {
  restrict: 'E',
  bindings: {},
  template: _commonicdchanges2.default,
  controller: _commonicdchanges4.default,
  controllerAs: 'vm'
};

exports.default = commonicdchangesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchanges/commonicdchanges.component.js